use '@use-gpu/wgsl/use/view'::{ depthToView, getViewNearFar };
use '@use-gpu/wgsl/display/depth'::{ displayDepth };

@export struct OITSample {
  color: vec4<f32>,
  alpha: f32,
};

@export fn getOITSample1(color: vec4<f32>, depth: f32) -> OITSample {

  let d1 = depth; // reverse Z already applied
  let d1_3 = d1 * d1 * d1;
  let weight = color.a * max(1e-2, 3e3 * d1_3);

  return OITSample(
    color * weight,
    color.a
  );
};

@export fn getOITSample(color: vec4<f32>, depth: f32) -> OITSample {

  let z = depthToView(depth);
  let nf = getViewNearFar();

  let relativeZ = (abs(z) - nf.x) / (nf.y - nf.x);
  let relativeD = (1.0 - relativeZ) / (1.0 + relativeZ);

  let d1 = relativeD;
  let d1_3 = d1 * d1 * d1;
  let weight = color.a * max(1e-2, 3e3 * d1_3);

  return OITSample(
    color * weight,
    color.a
  );
};
